export default __webpack_public_path__ + "static/media/34.ced19b16.jpg";